import classNames from 'classnames'
import { ButtonHTMLAttributes } from 'react'

// A <button> with just an icon, without any extra styling.
export const PlainButton = (props: ButtonHTMLAttributes<HTMLButtonElement>) => (
  <button
    {...props}
    className={classNames(
      'inline hover-aa-supported appearance-none bg-transparent cursor-pointer disabled:shadow-none disabled:opacity-30 disabled:cursor-not-allowed',
      props.className
    )}
  >
    {props.children}
  </button>
)
